<template>
  <EventsCoursesListWithFiltersWrapper
    :title="$t('events.my_courses')"
    :event-type="EventType.Course"
    :list-type="EventsListTypeMap.Me"
  >
    <template #empty>
      <div class="flex flex-col gap-2 h-full justify-center items-center py-8">
        <template v-if="authStore.auth">
          <template v-if="eventsStore.filtersCount > 0">
            {{ $t('events.no_courses_with_filters') }}
          </template>
          <template v-else>
            <div>
              {{ $t('events.no_my_courses') }}
            </div>
            <BaseLink :to="'/academy'" class="block">
              {{ $t('events.upcoming_courses') }}
            </BaseLink>
          </template>
        </template>
        <template v-else>
          <div class="mb-2">
            {{ $t('events.login_to_see_my_courses') }}
          </div>
          <BaseButton
            theme="primary"
            look="border"
            @click="authStore.openLoginModal"
          >
            {{ $t('header.login') }}
          </BaseButton>
        </template>
      </div>
    </template>
  </EventsCoursesListWithFiltersWrapper>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useEvents } from '~/stores/events'
import { EventType, EventsListTypeMap } from '~/models/events'

const authStore = useAuth()
const eventsStore = useEvents()

useHeadMeta({
  title: 'My courses',
  description: 'My courses in WN Academy',
})
</script>
